import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConfigService } from './core/config.service';
import { LocalStorageService } from './core/local-storage.service';
import { FooterPortalService } from './core/services/footer-portal.service';
import { AppVersionService } from './core/services/app-version.service';
import { PlausibleService } from './core/plausible.service';
import { SidenavComponent } from './core/sidenav/sidenav.component';
import { UpdateOverlayComponent } from './core/update-overlay/update-overlay.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        SidenavComponent,
        CdkPortalOutlet,
        UpdateOverlayComponent
    ]
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild(CdkPortalOutlet, { static: true }) portalOutlet!: CdkPortalOutlet;

  constructor(
    translate: TranslateService,
    configService: ConfigService,
    localStorageService: LocalStorageService,
    private footerPortalService: FooterPortalService,
    protected appVersionService: AppVersionService, // Initialize version checking
    private router: Router,
    private plausible: PlausibleService
  ) {

    const storedLang = localStorageService._get('NG_TRANSLATE_LANG_KEY');

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(storedLang || configService.environment.defaultLanguage || 'da');
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => this.plausible.track('pageview'));
  }

  ngAfterViewInit() {
    console.log('AppComponent ngAfterViewInit');
    this.footerPortalService.setOutlet(this.portalOutlet);
  }
}
